/* =========  CONFIG  ========= */
const tierConfig = {
  bronze: {
    variantId: '49748719665428',
    titleText: 'BRONZE',
    plans: [
      { id: '690248778004', label: 'Every 2 weeks', price: '15.00',  period: 'Per 2 Weeks' },
      { id: '690230034708', label: 'Every month',   price: '29.99',  period: 'Per Month', default: true }
    ]
  },
  silver: {
    variantId: '49748719698196',
    titleText: 'SILVER',
    plans: [
      { id: '690248778004', label: 'Every 2 weeks', price: '35.00',  period: 'Per 2 Weeks' },
      { id: '690230034708', label: 'Every month',   price: '69.99',  period: 'Per Month', default: true }
    ]
  },
  gold: {
    variantId: '49748719730964',
    titleText: 'GOLD',
    plans: [
      { id: '690248778004', label: 'Every 2 weeks', price: '60.00',  period: 'Per 2 Weeks' },
      { id: '690230034708', label: 'Every month',   price: '119.99', period: 'Per Month', default: true }
    ]
  },
  extreme_collector: {
    variantId: '49931342315796',
    titleText: 'EXTREME COLLECTOR',
    plans: [
      { id: '690248778004', label: 'Every 2 weeks', price: '125.00', period: 'Per 2 Weeks' },
      { id: '690230034708', label: 'Every month',   price: '249.99', period: 'Per Month', default: true }
    ]
  },
  i_have_a_problem: {
    variantId: '49997293945108',
    titleText: 'I HAVE A PROBLEM',
    plans: [
      { id: '690248778004', label: 'Every 2 weeks', price: '250.00', period: 'Per 2 Weeks' },
      { id: '690230034708', label: 'Every month',   price: '499.99', period: 'Per Month', default: true }
    ]
  }
};

/* =========  HELPERS  ========= */
const cardSelector = '[class^="pricing-table-item-template--"][class*="__ss_pricing_table_3_"]';
const btnSelector  = 'a[class^="pricing-table-btn-template--"][class*="__ss_pricing_table_3_"]';

function waitFor(selector, timeout = 5000) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(selector)) return resolve();
    const mo = new MutationObserver(() => {
      if (document.querySelector(selector)) { mo.disconnect(); resolve(); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => { mo.disconnect(); reject('Timeout'); }, timeout);
  });
}

function removeSubscriptionItems() {
  const subscriptionVariantIds = Object.values(tierConfig).map(t => String(t.variantId));
  return fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const removePromises = cart.items
        .filter(item => subscriptionVariantIds.includes(String(item.variant_id)))
        .map(item =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          })
        );
      return Promise.all(removePromises);
    });
}

/* =========  MAIN ========= */
document.addEventListener('DOMContentLoaded', async () => {
  try {
    await waitFor(cardSelector);
  } catch (err) {
    console.error('Timeout waiting for cards');
    return;
  }

  Object.values(tierConfig).forEach(tier => {
    const cards = [...document.querySelectorAll(cardSelector)]
      .filter(c => !c.dataset.dropdown)
      .filter(c => c.textContent.toUpperCase().includes(tier.titleText));

    cards.forEach(card => {
      const btn = card.querySelector(btnSelector);
      const priceBlock = card.querySelector('p[class*="pricing-table-price"]');
      if (!btn || !priceBlock) return;

      const select = document.createElement('select');
      select.style.cssText = 'width:100%;border:1px solid #ccc;border-radius:6px;padding:8px;margin-top:12px';
      tier.plans.forEach(p => {
        select.appendChild(new Option(p.label, p.id, p.default, p.default));
      });

      card.insertBefore(select, btn);

      const getPlan = id => tier.plans.find(p => p.id === id);
      const render  = plan => priceBlock.innerHTML = `$${plan.price}<span>${plan.period}</span>`;
      render(getPlan(select.value));
      select.addEventListener('change', e => render(getPlan(e.target.value)));

      let chosenPlan = select.value;
      select.addEventListener('change', e => chosenPlan = e.target.value);

      btn.addEventListener('click', async e => {
        e.preventDefault();
        btn.classList.add('opacity-50', 'pointer-events-none');

        try {
          await removeSubscriptionItems(); // Always clear subs first

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: tier.variantId,
              quantity: 1,
              selling_plan: chosenPlan
            })
          });

          window.location.href = '/checkout';
        } catch (err) {
          console.error('Error processing cart:', err);
          btn.classList.remove('opacity-50', 'pointer-events-none');
          alert('Something went wrong. Please refresh and try again.');
        }
      });

      card.dataset.dropdown = '1';
    });
  });
});
